import { Plugin } from './plugin';
import { LoggerService } from 'rainbow-web-sdk/services/core/logger.service';
import { PersonalDirectoryService } from 'rainbow-web-sdk/services/directory/personal-directory.service';

export class PersonalDirectoryPlugin extends Plugin {
    public static initialize(): PersonalDirectoryPlugin {
        Plugin.initialize();

        if (!window.rainbow.plugins[PersonalDirectoryPlugin.name]) {
            const logger = LoggerService.getInstance();
            logger.info("[PersonalDirectoryPlugin] initialized");
            window.rainbow.plugins[PersonalDirectoryPlugin.name] = new PersonalDirectoryPlugin();
            PersonalDirectoryService.getInstance();
        }
        return window.rainbow.plugins[PersonalDirectoryPlugin.name];
    }

    private constructor() {
        super();
    }
}
